export default {
  methods: {
    duplicateModule(module) {
      this.$store.dispatch("membersModules/duplicate", module.id).then(() => {
        this.$store.dispatch("membersModules/get", this.params).then(() => {
          setTimeout(this.refresh, 2000);
          this.$message.success(
            "Módulo duplicado com sucesso. Em instantes ele estará disponível em sua lista de conteúdos."
          );
        });
      });
    },
    duplicateLesson(lesson) {
      this.$store.dispatch("membersLessons/duplicate", lesson.id).then(() => {
        setTimeout(this.refresh, 2000);
        this.$message.success(
          "Aula duplicada com sucesso. Em instantes sua aula estará disponível em sua lista de conteúdos."
        );
      });
    },
    reorderNested({ sub_modules, module }) {
      module.sub_modules = sub_modules;
      for (let i in sub_modules) {
        sub_modules[i].sort = i;
        sub_modules[i].parent = module.id;
      }
      this.saveOrder();
    },
    reorderLessons({ lessons, module }) {
      module.lessons = lessons;
      for (let i in lessons) {
        lessons[i].sort = i;
        lessons[i].module = module.id;
      }
      this.saveOrderLessons();
    },
    saveOrder() {
      this.$store.dispatch(
        "membersModules/reorder",
        this.modules.reduce(
          (prev, curr) => [...prev, curr, ...curr.sub_modules],
          []
        )
      );
    },
    saveOrderLessons() {
      this.$store.dispatch(
        "membersLessons/reorder",
        this.modules.reduce(
          (prev, curr) => [
            ...prev,
            ...curr.lessons,
            ...curr.sub_modules.reduce(
              (prev, curr) => [...prev, ...curr.lessons],
              []
            )
          ],
          []
        )
      );
    },
    editModule(module) {
      this.$router.push({
        name: "product-members-module-edit",
        params: {
          id: this.$route.params.id,
          module_id: module.id
        }
      });
    },
    editSubModule(submodule) {
      this.$router.push({
        name: "product-members-submodule-edit",
        params: {
          id: this.$route.params.id,
          module_id: submodule.parent || submodule.opened_module_id,
          submodule_id: submodule.id
        }
      });
    },
    removeModule(module) {
      this.$store
        .dispatch("membersModules/delete", module.id)
        .then(this.refresh);
    },
    removeSubmodule(module) {
      this.$store
        .dispatch("membersModules/deleteSub", module.id)
        .then(this.refresh);
    },
    editLesson(lesson) {
      this.$router.push({
        name: "product-members-lesson-edit",
        params: {
          id: this.$route.params.id,
          lesson: lesson.id
        }
      });
    },
    removeLesson(lesson) {
      this.confirmationMessage = "Tem certeza que deseja excluir essa aula?";
      this.itemToRemove = lesson;
      this.removeConfirmation = true;
    },
    editQuizz(quizz) {
      this.$router.push({
        name: "product-members-module-quizz-edit",
        params: {
          id: this.$route.params.id,
          module_id: quizz.opened_module_id,
          quizz_id: quizz.code
        }
      });
    },
    removeQuizz(quizz) {
      this.confirmationMessage =
        "Tem certeza que deseja excluir essa avaliação?";
      this.itemToRemove = quizz;
      this.removeConfirmation = true;
    },
    removeItem(item) {
      if (item.type === "lesson") {
        this.$store
          .dispatch("membersLessons/delete", item.id)
          .then(this.refresh);
      } else {
        this.$store
          .dispatch("membersQuizzes/delete", item.code)
          .then(this.refresh);
      }
    }
  }
};
